import { NewPageComponent } from '../../templates/new-page/new-page.component';
import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import { ActivatedRoute } from '@angular/router';
import { ExtraService } from '../../core/services/extra.service';
import { DropDownComponent } from '../../layout/drop-down/drop-down.component';
import { from } from 'rxjs/observable/from';
import { NewPageList } from '../../core/models/new-page-list';
import { ListWithinList } from '../../core/models/list-within-list';
import { Constants } from '../../core/config/Constants';


@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css'],
  providers: [ExtraService]
})
export class ContactUsComponent {

  public page = {
    title: "Contact Us",
    slug: "contact"
  };

  constructor() {

  }



}






// WEBPACK FOOTER //
// /app/src/app/user/contact-us/contact-us.component.ts